import type { ScreenSchema } from './types';

/**
 * Schema for the `slides` template.
 *
 * Rendered by screen-slides.vue. Each slide is a full uc-screen instance whose
 * audio is triggered when the user navigates to it (via `open(i)`) or when the
 * scroll section first becomes active.
 *
 * `managesOwnSectionAudio` prevents uc-screen's generic sectionActive watcher
 * from firing — screen-slides.vue drives audio timing via its own ScrollTrigger
 * and the `open(i)` function.
 *
 * Per-slide audio is resolved by useChildScreenAudio().resolveChildIntro(),
 * using each slide's own schema (based on its `template` field).
 *
 * Note: nested template audio within a slide (e.g. a question's intro queued
 * after the slide intro) is handled via the S3 data-queue-audio path in the
 * current implementation. JiT queuing for nested slide content is deferred.
 */
const slidesSchema: ScreenSchema = {
  template: 'slides',
  managesOwnSectionAudio: true,
  slots: {}
};

export default slidesSchema;
